import ActionTypes from './actionTypes';

const { SET_MONETATE_EXPERIENCES } = ActionTypes;

const setExperiences = (experiences) => ({
  type: SET_MONETATE_EXPERIENCES,
  payload: { experiences },
});

export { setExperiences };
